module.exports = __webpack_public_path__ + "img/edit.1f43c36d.svg";